import { useEffect, useState } from "react";

import { type TimesheetPeriod, timesheetApi } from "../services";

type Result = {
  key: string;
  count: number | null;
};

export function usePlannedEventsCount(
  employeeId: number | null,
  period: TimesheetPeriod,
  enabled: boolean,
): { loading: boolean; count: number | null; error: boolean } {
  const [result, setResult] = useState<Result | null>(null);

  const key =
    enabled && null !== employeeId
      ? `${employeeId}:${period.start}:${period.end}`
      : null;

  useEffect(() => {
    if (null === key || null === employeeId) {
      return;
    }

    const controller = new AbortController();

    timesheetApi
      .countPlannedEvents(employeeId, period, { signal: controller.signal })
      .then((count) => setResult({ key, count }))
      .catch((error: unknown) => {
        if (!controller.signal.aborted) {
          console.error("Timesheet planning check failed:", error);
          setResult({ key, count: null });
        }
      });

    return () => controller.abort();
  }, [key, employeeId, period]);

  const current = null !== result && result.key === key ? result : null;

  return {
    loading: null !== key && null === current,
    count: current?.count ?? null,
    error: null !== current && null === current.count,
  };
}
